import { useState } from 'react'
import { Button } from '../../components/ui'

const statusOptions = ['active', 'planning', 'paused', 'archived']

function ProductForm({ onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    name: '',
    status: 'planning',
    repo_url: '',
    docs_url: '',
    dashboard_url: '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!formData.name) return
    onSubmit({
      ...formData,
      repo_url: formData.repo_url || null,
      docs_url: formData.docs_url || null,
      dashboard_url: formData.dashboard_url || null,
    })
  }

  return (
    <form onSubmit={handleSubmit} className="stack">
      <div className="form-group">
        <label className="form-label">Product Name</label>
        <input
          className="form-input"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="WhenWorks"
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Status</label>
        <select
          className="form-select"
          name="status"
          value={formData.status}
          onChange={handleChange}
        >
          {statusOptions.map(status => (
            <option key={status} value={status}>{status}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="form-label">Repo URL</label>
        <input
          className="form-input"
          name="repo_url"
          value={formData.repo_url}
          onChange={handleChange}
          placeholder="https://github.com/second-shift/whenworks"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Docs URL</label>
        <input
          className="form-input"
          name="docs_url"
          value={formData.docs_url}
          onChange={handleChange}
          placeholder="https://docs.whenworks.com"
        />
      </div>

      <div className="form-group">
        <label className="form-label">Dashboard URL</label>
        <input
          className="form-input"
          name="dashboard_url"
          value={formData.dashboard_url}
          onChange={handleChange}
          placeholder="https://dashboard.whenworks.com"
        />
      </div>

      <div className="modal-actions">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" loading={loading}>
          Add Product
        </Button>
      </div>
    </form>
  )
}

export default ProductForm
